/***********************
 * Remove application
***********************/
if( document.querySelector(".remove-application") ) {
    const removeApplication = document.querySelector(".remove-application");
    const confirmRemoveAd = document.querySelector('.custom-message-modal-btn.confirm');
    const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');
    const modal = document.querySelector('.custom-message-modal-overlay');

    if (modal) {
        modal.addEventListener('click', function(e) { 
            if (e.target.classList.contains('removed')) {
                modal.classList.remove('d-flex');
                e.target.remove();
            }
        });
    }

    removeApplication.addEventListener('click', function() {
        const employeeJob = removeApplication.getAttribute("data-job");

        confirmRemoveAd.style.display = 'block';
        confirmBtnCancel.style.display = 'block';

        confirmRemoveAd.setAttribute('data-job', employeeJob);
        confirmRemoveAd.setAttribute('data-action', 'remove');

        const modalMessage = document.querySelector('.custom-message-modal-body p');
        if (modalMessage) {
            modalMessage.textContent = 'Are you sure you want to remove your application ?';
        }

        const modalTriggerBtn = document.querySelector('.open-modal-btn');
        if (modalTriggerBtn) {
            modalTriggerBtn.click();
        }

    });

    confirmRemoveAd.addEventListener('click', function() {
        const employeeJob = this.getAttribute('data-job');
        const actionPost = this.getAttribute('data-action');
        
        if (actionPost !== 'remove') {
            return;
        }
    
        const modalBody = document.querySelector('.custom-message-modal-body p');
    
        if (modalBody) {
            modalBody.textContent = 'Removing application. Please wait...';
            confirmRemoveAd.style.display = 'none';
            confirmBtnCancel.style.display = 'none';
    
            fetch(ajax_callback_data.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'yakkly_employee_remove_job_application',
                    jobId: employeeJob,
                    nonce: ajax_callback_data.ajax_nonce
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    modalBody.textContent = 'Application removed successfully';
    
                    window.location.href = data.data.redirect_url;
                    return;
                } else {
                    modalBody.textContent = 'Failed to remove Application.';
                    console.error('Failed to remove Application.');
                }
            })
            .catch(err => {
                modalBody.textContent = 'An error occurred.';
                console.error(err);
            });
        }
    });
    
}